module.exports = __webpack_public_path__ + "static/media/energetic_neutral.a149a2d5.svg";